import React, { useMemo, useState } from 'react';
import { SCREEN_SIZES } from 'constants/config';
import useWindowSize from 'hooks/useWindowSize';
import cn from 'classnames';
import UARecorder from 'components/shared/UARecorder';

const UniversalAudioRecorderButton = ({ recordButtonText, saveMedia }) => {
  const [isUARUpen, setIsUarOpen] = useState(false);
  const [isUARReady, setIsUARReady] = useState(false);

  const UAR = useMemo(() => {
    const handleComplete = data => {
      setIsUarOpen(false);

      if (data?.storageId) {
        saveMedia({
          token: data?.storageId,
          fileFormat: data?.format,
          containerId: data?.containerId,
          size: data?.sizeBytes,
          duration: data?.durationSeconds,
          storageService: data?.storageService,
        });
      }
    };

    return (
      <UARecorder
        isOpen={isUARUpen}
        onCancel={() => setIsUarOpen(false)}
        bssUploadOptions={{
          owner: 'srs-lessons',
          container: 'readiness',
          isFullContainerName: false,
        }}
        handleComplete={handleComplete}
        onUARReady={() => setIsUARReady(true)}
      />
    );
  }, [isUARUpen, saveMedia]);

  const { width } = useWindowSize();

  if (width < SCREEN_SIZES.SM) {
    return <div />;
  }

  return (
    <>
      <button
        type="button"
        className={cn({
          'uvr-btn ba-videorecorder-chooser-button-0 CustomColor--borderColor': true,
          Button: true,
          'Button--primary mb-12 fz-16': true,
        })}
        onClick={() => setIsUarOpen(true)}
        disabled={!isUARReady}
      >
        {recordButtonText}
      </button>
      {UAR}
    </>
  );
};

export default UniversalAudioRecorderButton;
